import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles((theme) => ({
	textWrapper: {
		display: "inline-flex",
		alignItems: "center",
		gap: theme.spacing(1),
		borderRadius: theme.spacing(0.5),
		padding: theme.spacing(0.25, 0.75),
		cursor: "pointer",
		transition: "background-color 0.15s",
		"&:hover": {
			backgroundColor: "rgba(0, 0, 0, 0.06)"
		}
	},
	saving: {
		opacity: 0.5,
		cursor: "default",
		pointerEvents: "none",
		"&:hover": {
			backgroundColor: "transparent"
		}
	},
	text: {
		maxWidth: 380,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
		display: "inline-block",
		verticalAlign: "middle"
	},
	editIcon: {
		color: "rgba(0, 0, 0, 0.54)",
		flexShrink: 0
	},
	input: {
		verticalAlign: "middle",
		border: "1px solid rgba(0, 0, 0, 0.23)",
		borderRadius: theme.spacing(0.5),
		paddingLeft: theme.spacing(0.75),
		"&.Mui-focused": {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 2px ${theme.palette.primary.main}33`
		},
		"& input": {
			maxWidth: 320,
			padding: theme.spacing(0.25, 0),
			fontSize: "1rem",
			fontFamily: "inherit",
			outline: "none"
		}
	},
	confirmIcon: {
		color: colors.green[700]
	}
}))

export default useStyles
